var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 5C3.6 3.67392 4.10571 2.40215 5.00589 1.46447C5.90606 0.526784 7.12696 0 8.4 0C9.67304 0 10.8939 0.526784 11.7941 1.46447C12.6943 2.40215 13.2 3.67392 13.2 5C13.2 6.32608 12.6943 7.59785 11.7941 8.53553C10.8939 9.47322 9.67304 10 8.4 10C7.12696 10 5.90606 9.47322 5.00589 8.53553C4.10571 7.59785 3.6 6.32608 3.6 5ZM0 18.8398C0 14.9922 2.9925 11.875 6.68625 11.875H10.1138C13.8075 11.875 16.8 14.9922 16.8 18.8398C16.8 19.4805 16.3013 20 15.6862 20H1.11375C0.49875 20 0 19.4805 0 18.8398ZM22.8488 20H17.6775C17.88 19.6328 18 19.207 18 18.75V18.4375C18 16.0664 16.9838 13.9375 15.3825 12.5078C15.4725 12.5039 15.5588 12.5 15.6488 12.5H17.9513C21.2925 12.5 24 15.3203 24 18.8008C24 19.4648 23.4825 20 22.8488 20ZM16.2 10C15.0375 10 13.9875 9.50781 13.2263 8.71484C13.965 7.67578 14.4 6.39062 14.4 5C14.4 3.95312 14.1525 2.96484 13.7138 2.09766C14.4113 1.56641 15.27 1.25 16.2 1.25C18.5213 1.25 20.4 3.20703 20.4 5.625C20.4 8.04297 18.5213 10 16.2 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e410cf13b2df130869ca036e07ede902.svg";
export { ForwardRef as ReactComponent };